/**
 * Best-effort cover snapshot: find the largest on-screen <canvas> (the unified
 * render canvas / a frame canvas), downscale it, and return a JPEG data URL.
 * Returns null when there's no usable canvas (DOM-only render, jsdom) or the
 * draw/encode fails (e.g. a tainted canvas) — callers fall back to a placeholder.
 */
export function captureCanvasCover(maxEdge = 640): string | null {
  try {
    const canvases = Array.from(document.querySelectorAll('canvas')) as HTMLCanvasElement[];
    const src = canvases
      .filter((c) => c.width > 0 && c.height > 0)
      .sort((a, b) => b.width * b.height - a.width * a.height)[0];
    if (!src) return null;
    const scale = Math.min(1, maxEdge / Math.max(src.width, src.height));
    const w = Math.max(1, Math.round(src.width * scale));
    const h = Math.max(1, Math.round(src.height * scale));
    const out = document.createElement('canvas');
    out.width = w; out.height = h;
    const ctx = out.getContext('2d');
    if (!ctx) return null;
    ctx.drawImage(src, 0, 0, w, h);
    return out.toDataURL('image/jpeg', 0.8);
  } catch {
    return null;
  }
}
